import { RenderElementProps } from "components/ManualBuilder/types";
import { ElementRenderer } from "../elementMap";

export const paragraphElement: ElementRenderer =
  () =>
  ({ attributes, children }: RenderElementProps) =>
    <p {...attributes}>{children}</p>;

export const ulElement: ElementRenderer =
  () =>
  ({ attributes, children }: RenderElementProps) => {
    return (
      <ul {...attributes} className="pl-5 my-1 list-disc">
        {children}
      </ul>
    );
  };

export const olElement: ElementRenderer =
  () =>
  ({ attributes, children }: RenderElementProps) => {
    return (
      <ol {...attributes} className="pl-5 my-1 list-decimal">
        {children}
      </ol>
    );
  };

export const liElement: ElementRenderer =
  () =>
  ({ attributes, children }: RenderElementProps) =>
    (
      <li {...attributes} className="mb-0.5">
        {children}
      </li>
    );
